<template>
  <div class="callback-container">
    <div class="loading-spinner"></div>
    <p>Completing authentication...</p>
  </div>
</template>

<script>
import { Auth } from '@aws-amplify/auth'
import { onMounted } from 'vue'
import { useRouter } from 'vue-router'

export default {
  name: 'Callback',
  setup() {
    const router = useRouter()

    onMounted(async () => {
      try {
        // Handle the callback
        const authUser = await Auth.currentAuthenticatedUser()
        console.log('Auth callback completed, user:', authUser)
        
        // Inspect the token payload
        if (authUser.signInUserSession?.idToken?.payload) {
          console.log('ID Token payload:', authUser.signInUserSession.idToken.payload)
        }
        
        // Check attributes
        if (authUser.attributes) {
          console.log('Auth user attributes:', authUser.attributes)
        } else {
          console.log('No attributes found in auth user, using token payload for user data')
        }
        
        // Redirect to home page after successful authentication
        router.push('/')
      } catch (error) {
        console.error('Authentication error:', error)
        router.push('/login')
      }
    })
  }
}
</script>

<style scoped>
.callback-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
  background-color: #f5f5f5;
}

.loading-spinner {
  width: 50px;
  height: 50px;
  border: 5px solid #f3f3f3;
  border-top: 5px solid #3498db;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-bottom: 20px;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

p {
  color: #666;
  font-size: 1.2em;
}
</style> 